import React, { useEffect } from 'react';
import liveChatWidget from '@/lib/utils/liveChatWidget';
import { useIsMounted } from '@/hooks';

export default function LiveChatWidget(): React.ReactElement {
  const isMounted = useIsMounted();

  useEffect(() => {
    if (isMounted && typeof window !== 'undefined') {
      liveChatWidget('https://chat.xsolla.com/widget', 'widget');
    }
  }, [isMounted]);

  return <></>;
}
